import React from 'react'
import { useAppSelector } from 'app/hooks'
import { reportMarketingEvent, resolveMarketingEventLink } from 'helpers/marketingTracking'
import { LocationLinkContent, LocationLinkProps } from './LocationLinkContent'

export { formatAddress, formatLocation } from './LocationLinkContent'

export function LocationLink(props: LocationLinkProps) {
    const project = useAppSelector((state) => state.app.projectCurrent[0])
    const organization = useAppSelector((state) => state.app.organization)
    const directionsLink: any = resolveMarketingEventLink(project, organization, 'directions')
    const trackDirections = (event) => {
        event.stopPropagation()
        reportMarketingEvent({
            app: project,
            organization,
            eventName: directionsLink?.eventName || directionsLink?.event_name || 'directions_click',
            label: directionsLink?.label || 'project_directions',
            conversionActionId: directionsLink?.conversionActionId || directionsLink?.conversion_action_id,
            source: 'cta',
            mappingEnabled: true,
        })
    }

    return <LocationLinkContent {...props} trackDirections={trackDirections} />
}
